export default val => (
  val !== 'false' && val !== 'FALSE' && !!val
);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/reverb-js-common/to_boolean.js